import Search from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-empty-result/assets/search.png";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = () => {
  const router = useRouter();
  return (
    <div className="flex flex-col items-center gap-6 p-10">
      <LazyImage alt="search" src={Search?.src} />
      <div className="flex flex-col items-center gap-2">
        <div className="text-subtitle-1">نتیجه‌ای یافت نشد.</div>
        <div className="text-caption text-on-surface-medium-emphasis">
          متاسفانه اتاقی متناسب با تاریخ یا فیلتر های انتخابی شما وجود ندارد.
        </div>
      </div>
      {Object.keys(router?.query)?.some(
        (value) => value?.startsWith("roomFilter_")
      ) && (
        <Button
          StartIcon={
            <MaterialIcon
              className="text-headline-6"
              name="delete"
              variant="outlined"
            />
          }
          color="secondary"
          onClick={() =>
            router?.replace(
              {
                pathname: router.pathname,
                query: omit(
                  router?.query,
                  Object.keys(router?.query)?.filter(
                    (value) => value?.startsWith("roomFilter_")
                  )
                )
              },
              undefined,
              { shallow: true, scroll: false }
            )
          }
          text="حذف فیلترها"
          variant="outline"
        />
      )}
    </div>
  );
};

export const HotelReserveEmptyResult = memo(Component, deepCompare);
